<template>
  <section>
    <layout></layout>
  </section>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import layout from "@/components/layout/layout";

  export default {
    name: 'App',
    components: {
      layout
    }
  }
</script>

<style>
.overlay {
  margin-right: -20px;
}
</style>
